// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2w6dI","errorLogs":"EditorFooter_errorLogs__1MrQn"};